
import React, {
  useEffect, useState, useCallback, useRef, useMemo,
} from 'react';
import { IconClose, IconCheck, IconLoading } from 'gatorcomponents';
import * as S from './AudioRecording.styles';
import { format } from 'date-fns';

const second = 1000;
const minute = second * 60;
const recordingTimeLimit = minute;

const AudioRecording = ({
  onCancel, onSend, isRecording, transcribing, locales, testId = 'audio-recording', whiteBackground,
}) => {
  const [timeStamp, setTimeStamp] = useState(0);
  const startTimeRef = useRef(null);
  const intervalRef = useRef(null);

  const handleOnSend = useCallback(() => {
    onSend && onSend();
  }, [onSend]);

  const handleOnCancel = useCallback(() => {
    onCancel && onCancel();
  }, [onCancel]);

  const formattedTime = useMemo(() => format(new Date(timeStamp), 'mm:ss'), [timeStamp]);

  const recordLabel = useMemo(() => (transcribing ? locales.transcribingLabel : locales.recordingLabel), [transcribing, locales.transcribingLabel, locales.recordingLabel]);

  useEffect(() => {
    if (isRecording) {
      startTimeRef.current = Date.now();
      setTimeStamp(0);

      intervalRef.current = setInterval(() => {
        const currentTime = Date.now();
        const timerMs = currentTime - startTimeRef.current;

        if (timerMs >= recordingTimeLimit) {
          clearInterval(intervalRef.current);
          handleOnSend();
          return;
        }

        setTimeStamp(timerMs);
      }, 1000);

      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      };
    }

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    setTimeStamp(0);
  }, [isRecording, handleOnSend]);


  useEffect(() => () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  }, []);

  return (
    <S.Wrapper data-testid={testId}>
      <S.RecordingBar $whiteBackground={whiteBackground}>
        <S.RecordFeedbackLabel>{recordLabel}</S.RecordFeedbackLabel>
        <S.RecordingTime data-testid="recording-time">{formattedTime}</S.RecordingTime>
      </S.RecordingBar>
      <S.ButtonsWrapper>
        {isRecording && (
          <S.Button $type="cancel" onClick={handleOnCancel} data-testid="cancel-audio-button">
            <IconClose size="md" color="highPure" />
          </S.Button>
        )}
        <S.Button
          $type="record"
          onClick={handleOnSend}
          $isLoading={transcribing}
          disabled={transcribing}
          data-testid="send-audio-button"
        >
          {!transcribing ? <IconCheck color="highPure" size="md" /> : <IconLoading size="md" />}
        </S.Button>
      </S.ButtonsWrapper>
    </S.Wrapper>
  );
};

export default AudioRecording;
